import { getIsUnlimitedFeedPage } from 'helpers/helpers';
import { ThemeContext } from 'hooks/themeContext';
import { useFetchFeed } from 'hooks/useFetchFeed';
import React, { Suspense, lazy, useContext, useRef } from 'react';

import { WallPost } from '../../types/types';

const DesktopFeed = lazy(() => import('components/DesktopFeed'));
const MobileFeed = lazy(() => import('components/MobileFeed'));
const UnlimitedFeed = lazy(() => import('components/UnlimitedFeed'));

function Feed() {
  const isMobile = useContext(ThemeContext);
  const bannerPosition = useRef(Date.now() % 2);
  const isUnlimitedFeed = getIsUnlimitedFeedPage();
  const { items, isLoading } = useFetchFeed(isUnlimitedFeed);

  return (
    <div className="FeedWrapper">
      <Suspense fallback={null}>
        {isUnlimitedFeed ? (
          <UnlimitedFeed
            isLoading={isLoading}
            items={items as WallPost[]}
            isMobile={isMobile}
          />
        ) : isMobile ? (
          <MobileFeed
            isLoading={isLoading}
            items={items as WallPost[]}
            bannerPosition={bannerPosition.current}
            isMobile={isMobile}
          />
        ) : (
          <DesktopFeed
            isLoading={isLoading}
            items={items as WallPost[]}
            bannerPosition={bannerPosition.current}
            isMobile={isMobile}
          />
        )}
      </Suspense>
    </div>
  );
}

export default Feed;
